import React from 'react';
import Drawer from '@material-ui/core/Drawer';

const TemporaryDrawer = (props) => {

    return (
        <div>

            <Drawer anchor="right" open={props.isOpen} variant="persistent" /*onClose={toggleDrawer('right', false)}*/>
                <div>
                    {props.children}
                </div>
            </Drawer>
        </div>
    );
}

export default TemporaryDrawer;


